module.exports = __webpack_public_path__ + "media/svg-new/heart-6a9d3203.svg";